export const ROUTES = {
  HOME: '/',
  SERVICES: '/repair-services',
  SERVICE_DETAIL: '/repair-services/:id',
  ABOUT: '/about-us',
  CONTACT: '/contact-us',
  IMPRESSUM: '/impressum',
  DATENSCHUTZ: '/datenschutz',
  PREISE: '/preise',
} as const;

export const getServiceDetailRoute = (id: string): string => `${ROUTES.SERVICES}/${id}`;
